module.exports = __webpack_public_path__ + "static/media/icons_Bilan des cicatrices de la face.9040400e.svg";